import {
  defineStore,
} from "pinia";

type Theme = "light" | "dark";

interface ThemeState {
  theme: Theme;
}

const STORAGE_KEY = "ai-tutor-theme";

export const useThemeStore = defineStore("theme", {
  state: (): ThemeState => ({
    theme: "light",
  }),

  getters: {
    isDark: (state): boolean => state.theme === "dark",
  },

  actions: {
    initialize(): void {
      if (typeof window === "undefined") {
        return;
      }

      const stored = localStorage.getItem(STORAGE_KEY) as Theme | null;
      const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;

      this.theme = stored || (prefersDark ? "dark" : "light");
      this.applyTheme();
    },

    setTheme(theme: Theme): void {
      this.theme = theme;
      this.applyTheme();

      if (typeof window !== "undefined") {
        localStorage.setItem(STORAGE_KEY, theme);
      }
    },

    toggle(): void {
      this.setTheme(this.theme === "dark" ? "light" : "dark");
    },

    applyTheme(): void {
      if (typeof document === "undefined") {
        return;
      }

      const html = document.documentElement;
      const body = document.body;
      const nuxtRoot = document.getElementById("__nuxt");

      const isDark = this.theme === "dark";
      html.classList.toggle("dark", isDark);
      body.classList.toggle("dark", isDark);
      nuxtRoot?.classList.toggle("dark", isDark);

      html.style.colorScheme = isDark ? "dark" : "light";
    },
  },
});
